import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';

import api from 'services';
import { updateCargoOrder } from 'actions/cargoes/orders';

class CreateNewRegion extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            openDialog: false,
            canRequestNewRegion: true,
            value: '',
            openSnackbar: false,
            message: '',
        };
    
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.onInputNewRegion = this.onInputNewRegion.bind(this);
        this.sendNewRegion = this.sendNewRegion.bind(this);
        this.onSnackbarClose = this.onSnackbarClose.bind(this);
    }
    
    sendNewRegion() {
        api.checkAndCreateRegion(this.state.value)
            .then((response) => {
                if (response.status === 200) {
                    return this.setState({
                        openSnackbar: true,
                        message: 'Region success added',
                        openDialog: false,
                        canRequestNewRegion: true,
                        value: '',
                    }, () => {
                        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);

                        if (this.props.typeOfPort === 'loading') {
                            newCargoOrder.loadingPortsMap[this.props.numberOfPort].namePort = response.data.data.name;
                            newCargoOrder.loadingPortsMap[this.props.numberOfPort].idPort = response.data.data._id;
                        } else {
                            newCargoOrder.unloadingPortsMap[this.props.numberOfPort].namePort = response.data.data.name;
                            newCargoOrder.unloadingPortsMap[this.props.numberOfPort].idPort = response.data.data._id;
                        }

                        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
                    });
                }
    
                return this.setState({
                    openSnackbar: true,
                    message: 'Region does not added',
                    openDialog: false,
                    canRequestNewRegion: true,
                    value: '',
                });
            })
            .catch(() => {
                return this.setState({
                    openSnackbar: true,
                    message: 'Region does not added',
                    openDialog: false,
                    canRequestNewRegion: true,
                    value: '',
                });
            });
    }
    
    handleCloseDialog() {
        this.setState({
            openDialog: false,
            canRequestNewRegion: true,
            value: '',
        });
    }
    
    handleOpenDialog() {
        this.setState({
            openDialog: true,
            canRequestNewRegion: true,
        });
    }
    
    onInputNewRegion(e) {
        let canRequestNewRegion = true;
        const value = e.target.value;
        
        if (value.length > 0) {
            canRequestNewRegion = false;
        }
        
        this.setState({
            canRequestNewRegion,
            value,
        });
    }
    
    onSnackbarClose() {
        this.setState({
            openSnackbar: false,
            message: '',
        });
    }
    
    render() {
        const actions = [
            <FlatButton
                label='Cancel'
                primary
                onClick={this.handleCloseDialog}
            />,
            <FlatButton
                label='Send'
                primary
                disabled={this.state.canRequestNewRegion}
                onClick={this.sendNewRegion}
            />,
        ];
        
        return (
            <div>
                <RaisedButton
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px'}}
                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                    label='Create new region'
                    onClick={this.handleOpenDialog}
                    primary
                />
                
                <Snackbar
                    open={this.state.openSnackbar}
                    message={this.state.message}
                    autoHideDuration={2000}
                    onRequestClose={this.onSnackbarClose}
                />
                
                <Dialog
                    title='Create new region'
                    actions={actions}
                    modal
                    open={this.state.openDialog}
                >
                    <TextField
                        hintText='Enter new region'
                        floatingLabelFixed
                        onChange={this.onInputNewRegion}
                    />
                </Dialog>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            typeOfPort: ownProps.typeOfPort,
            numberOfPort: ownProps.numberOfPort,
            cargoOrder: ownProps.cargoOrder,
            numberOrderTable: ownProps.numberOrderTable,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(CreateNewRegion);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/CreateNewRegion.jsx